import { render, staticRenderFns } from "./examFace.vue?vue&type=template&id=e380501c&scoped=true"
import script from "./examFace.vue?vue&type=script&lang=js"
export * from "./examFace.vue?vue&type=script&lang=js"
import style0 from "./examFace.vue?vue&type=style&index=0&id=e380501c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e380501c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e380501c')) {
      api.createRecord('e380501c', component.options)
    } else {
      api.reload('e380501c', component.options)
    }
    module.hot.accept("./examFace.vue?vue&type=template&id=e380501c&scoped=true", function () {
      api.rerender('e380501c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/examCenterOwn/onlineExamOwn/module/examFace.vue"
export default component.exports